
import { hyperReviewActionTypes } from '@constants/actionTypes/ssapActionTypes';

export const INITIAL_STATE = false;

export default (state = INITIAL_STATE, action = {}) => {

    switch (action.type) {
        case hyperReviewActionTypes.SET_HYPER_REVIEW:
            return action.isHyperReview;

        case hyperReviewActionTypes.CLEAR_SSAP_STATE:
            return INITIAL_STATE;

        default:
            return state;
    }
};